import React, { ReactNode } from 'react';
import ReadOnlyField from './readOnlyField';
import { formatters } from 'utilities';

interface ReadOnlyDateFieldProps {
	label?: ReactNode;
	date?: string | Date;
}

export const ReadOnlyDateField: React.FC<React.PropsWithChildren<ReadOnlyDateFieldProps>> = (props) => {
	const { label, date } = props;

	return <ReadOnlyField label={label}>{date ? formatters.datetime.date(date) : ''}</ReadOnlyField>;
};

export default ReadOnlyDateField;
